import { apiLink } from '../../constants/env';
import { getAccessToken } from '../../funcs';
import axiosInstance, { AxiosAuth } from '../AxiosInstance';


const apiUsuario = {
    fetchApi: async (page, pageSize = 10) => {
        const URL = `/api/auth/paged?page=${page}&pageSize=${pageSize}`;
        return await AxiosAuth.get(URL, {
            headers: {
                'Authorization': `bearer ${getAccessToken()}`
            }
        })
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, usuario) => {
        const URL = `/api/auth/usuario/${id}`;
        return await AxiosAuth.put(URL, usuario)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    deleteApi: async (id) => {
        const URL = `/api/auth/status/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },

}

export default apiUsuario;

